<template>
  <div class="footer-container">
    <img class="footer-back" :src="require('../../assets/imgs/icon/footer-back.png')" @click="this.onBack" />
    <!-- 收藏按钮 -->
    <div v-if="this.showCollect == 1">
      <div class="collect-view" @click="clickCollect">
        <!-- <img style="width: 21px;height: 21px;" :src="require('../../assets/imgs/collect/coloect_yellow.png')"
          @click="clickCollect" /> -->
          <lottie
            style="width: 40px; left: -15px; height: 40px;"
            :options="defaultOptions"
            v-on:animCreated="handleAnimation"
          />
        <div v-if="isFavorite" 
            class="collect-cancel"
            >取消收藏</div>
        <div v-else 
            class="collect-text" >收藏</div>

      </div>
    </div>
    <div class="home-button" @click="this.onButtonClick">{{this.text}} </div>
  </div>
</template>

<script>
  import lottie from 'vue-lottie'
  import Anim from '../../assets/lottie/lottie-collect.json'
  import { Toast } from "vant";

  export default {
    name: "MoreFooterCollect",
    data() {
      return {
        defaultOptions: { animationData: Anim, loop: false, autoplay: false },
        defaultAnim: '',
      }
    },
    props: {
      text: {
        type: String,
        default: '',
      },
      onBack: {
        type: Function,
        default: () => { },
      },
      onButtonClick: {
        type: Function,
        default: () => { },
      },
      onClickCollect: {
        type: Function,
        default: () => { },
      },
      onClickCancelCollect: {
        type: Function,
        default: () => { },
      },
      isFavorite: {
        type: Boolean,
        default: false
      },
      showCollect: {
        type: Number,
        default: 1
      }
    },
    mounted() {
      // Toast(' 收藏 '+this.isFavorite)
      setTimeout(() => {
        console.log('----收藏-isFavorite foot---'+this.isFavorite)
        if(this.isFavorite){
          this.defaultAnim && this.defaultAnim.goToAndStop(800)
        }
      }, 500);
    },
    watch:{
      isFavorite(val, oldVal){
        // console.log('-----val----'+val)
        // console.log('-----oldVal----'+oldVal)
        if(!this.isFavorite){
          //1 取消成功
          this.defaultAnim.stop();
        }else{
          //2 收藏成功
          this.defaultAnim.play()
        }
      },
    },
    methods: {
      // onBack() {
      //   location.href = "/home";
      // },
      // onButtonClick() {},
      //==============lottie================
      handleAnimation(anim) {
       this.defaultAnim = anim;
        console.log("anim", anim);
      },

      clickCollect(){
        console.log('+++===>>>clickCollect...>>>')
        this.onClickCollect()
        // if (this.isFavorite) {
        //   this.defaultAnim.stop();
        //   // this.defaultAnim.goToAndPlay(100);
        // }else{
        //   this.defaultAnim.play()
        // } 
    },
    },
    components: {
      lottie
    }
  };
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .footer-container {
    position: fixed;
    bottom: 0;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    height: 62px;
    width: 100%;
    background: #ffffff;
    display: flex;
    align-items: center;
  }

  .footer-back {
    width: 62px;
    height: 62px;
  }

  .home-button {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    margin: 0 20px;
    width: 100%;
    border-radius: 16px;
    background: linear-gradient(right, #98CEFF, #3994E7);
  }

  .collect-view {
    justify-content: center;
    align-items: center;
    text-align : center;
    display: flex;
    flex-direction: column;
    margin: 0px -20px 0px 0px;
    width: 70px;
    /* background-color: #3994E7 */

  }
  .collect-cancel {
    font-size: 8px;
    color: #3994E7;
    margin-top: -6px;
    white-space: nowrap;
  }
  .collect-text {
    font-size: 8px;
    color: #999999;
    margin-top: -6px;
    white-space: nowrap;
  }
  .collect-lottie {
    width: 40px; 
    left: -15px; 
    height: 40px;
  }
</style>


// WEBPACK FOOTER //
// app/components/footer/MoreFooterCollect.vue